<script setup lang="ts">
defineProps<{
  show: boolean;
  prevLabel: string;
  nextLabel: string;
  prevId: string;
  nextId: string;
}>();
</script>

<template>
  <div v-show="show" class="phxsg-slider__nav-wrapper">
    <div :id="prevId" class="phxsg-slider__nav phxsg-slider__nav--prev">
      <slot name="prev" :label="prevLabel" />
    </div>

    <div :id="nextId" class="phxsg-slider__nav phxsg-slider__nav--next">
      <slot name="next" :label="nextLabel" />
    </div>
  </div>
</template>
